import React, { useState } from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import {
  Breadcrumb,
  Footer,
  Header,
  Numbering,
  PanelAccordion,
  Sidebar,
} from "../../components";
import "./style.scss";
import { items } from "./ListContentAccordion";

function JPbphtb() {
  useDocumentTitle("Pelayanan Bphtb- BAPENDA BEKASI");
  const [isActive, setIsActive] = useState(null);

  return (
    <div className="page">
      <Header active="JPbphtb" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / BPHTB" />
          <div className="page-title-wrapper">
            <div className="page-title">Pajak BPHTB</div>
          </div>
          <div className="jenis-pajak-title">
            <strong>Bea Perolehan Hak atas Tanah dan Bangunan</strong>
          </div>
          <div className="jenis-pajak-content">
            <p className="page-text">
            Bea Perolehan Hak atas Tanah dan Bangunan yang selanjutnya disingkat
BPHTB adalah Pajak atas perolehan hak atas tanah dan/atau bangunan.
Perolehan Hak atas Tanah dan/atau Bangunan adalah perbuatan atau
peristiwa hukum yang mengakibatkan diperolehnya hak atas tanah
dan/atau bangunan oleh orang pribadi atau badan.
Hak atas Tanah dan/atau Bangunan adalah hak atas tanah, termasuk hak
pengelolaan, beserta Bangunan di atasnya, sebagaimana dimaksud dalam
undang-undang di bidang pertanahan dan Bangunan.
            </p>
            <p className="page-text">
            Objek BPHTB adalah perolehan Hak atas Tanah dan/atau Bangunan. Perolehan Hak atas Tanah dan/atau Bangunan meliputi:
            </p>
            <p className="page-text">
            A. pemindahan hak karena:<br></br>
  1. jual beli;<br></br>
  2. tukar menukar;<br></br>
  3. hibah;<br></br>
  4. hibah wasiat;<br></br>
  5. waris;<br></br>
  6. pemasukan dalam perseroan atau badan hukum lainnya;<br></br>
  7. pemisahan hak yang mengakibatkan peralihan;<br></br>
  8. penunjukan pembeli dalam lelang;<br></br>
  9. pelaksanaan putusan hakim yang mempunyai kekuatan hukum
tetap;<br></br>
  10. penggabungan usaha;<br></br>
  11. peleburan usaha;<br></br>
  12. pemekaran usaha, atau<br></br>
  13. hadiah; dan<br></br>
B. pemberian hak baru karena;<br></br>
  1. kelanjutan pelepasan hak; atau<br></br>
  2. di luar pelepasan hak.
            </p>
            <p className="page-text"></p>
            Hak atas Tanah dan/atau Bangunan meliputi:
            <Numbering number="1" content="hak milik;" />
            <Numbering number="2" content="hak guna usaha;" />
            <Numbering number="3" content="hak guna bangunan;" />
            <Numbering number="4" content="hak pakai;" />
            <Numbering number="5" content="hak milik atas satuan rumah susun;" />
            <Numbering number="6" content="pengelolaan" />
<br></br>

            <p className="page-text">
DASAR HUKUM : <br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>
            
          </div>
          
          <div className="jenis-pajak-content">
            {items.map((item, index) => {
              return (
                <PanelAccordion
                  key={index}
                  label={item.label}
                  content={item.content}
                  index={index}
                  setIsActive={setIsActive}
                  isActive={isActive}
                />
              );
            })}
          </div>
  
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default JPbphtb;
